import React, { useCallback, useEffect, useState } from "react";
import baseUrl from "../../../../../api/baseUrl";
import { useNavigate } from "react-router-dom";
import BottomTab from "../../../../../components/pagination/BottomTab";
import {
  setloadeActive,
  setloadeDeactive,
} from "../../../../../redux/loader/loaderActions";
import { useDispatch, useSelector } from "react-redux";
import { RootState } from "../../../../../redux/store";
import AddButton from "../../../../../components/headers/AddButton";
import AllPaymentReport from "./AllPaymentReport";
import { FormProvider, SubmitHandler, useForm } from "react-hook-form";
import FormDate from "../../../../../components/formFeild/FormDate";
import FormCheck from "../../../../../components/formFeild/FormCheck";
import { toast } from "react-toastify";
interface FormData {
  payments: boolean;
  startDate: string;
  endDate: string;
}
function AllLastPayments() {
  const navigate = useNavigate();
  const [report, setreport] = useState(false);
  const [openpayments, setopenpayments] = useState(false);
  const [payment, setpayment] = useState([]);
  const [count, setCount] = useState(0);
  const [page, setPage] = useState(1);
  const [searchTerm, setSearchTerm] = useState<string>("");
  const search = useSelector((state: RootState) => state.searching.patientData);
  const methods = useForm<FormData>();
  const { watch, handleSubmit, reset } = methods;
  const dispatch = useDispatch();
  const getData = useCallback(
    (
      searchTerm: string,
      pageNum: number,
      startDate?: string,
      endDate?: string
    ) => {
      dispatch(setloadeActive());

      baseUrl
        .get("payment/getAllPayment", {
          headers: {
            keyword: searchTerm,
            page: pageNum,
          },
          params: {
            startDate: startDate,
            endDate: endDate,
          },
        })
        .then((response) => {
          dispatch(setloadeDeactive());
          setpayment(response.data.data);
          setCount(response.data.count);
        })
        .catch((error) => {
          dispatch(setloadeDeactive());
          console.log(error);
        });
    },
    [dispatch]
  );
  useEffect(() => {
    // Use searchTerm if available, otherwise fall back to Redux search
    const activeSearchTerm = searchTerm || search || "";
    getData(activeSearchTerm, page);
  }, [search, searchTerm, page, getData]);
  useEffect(() => {
    const { unsubscribe } = watch((value) => {
      if (value.startDate && value.endDate)
        getData(searchTerm || search || "", page, value.startDate, value.endDate);

      if (value.payments) {
        setopenpayments(true);
      } else {
        setopenpayments(false);
      }
    });
    return () => unsubscribe();
  }, [watch, searchTerm, search, page, getData]);
  const onPageChange = useCallback(
    (newPage: number) => {
      setPage(newPage);
      const activeSearchTerm = searchTerm || search || "";
      getData(activeSearchTerm, newPage);
    },
    [getData, searchTerm, search]
  );
  const closeModal = useCallback(() => {
    setreport(false);
  }, []);
  const onSubmit: SubmitHandler<FormData> = useCallback(
    async (data) => {
      try {
        const response = await baseUrl.get("client/payment/paymentReport", {
          responseType: "blob",
          params: {
            startDate: data.startDate,
            endDate: data.endDate,
            payments: data.payments,
          },
        });
        if (response.status === 204) {
          toast("No data found");
          return;
        }
        const pdfBlob = new Blob([response.data], { type: "application/pdf" });

        const link = document.createElement("a");
        link.href = URL.createObjectURL(pdfBlob);
        link.download = "downloaded.pdf";
        document.body.appendChild(link);

        link.click();

        URL.revokeObjectURL(link.href);
        document.body.removeChild(link);
      } catch (error) {
        console.error("Error downloading the PDF", error);
      }
    },
    [closeModal]
  );
  const methodReset = useCallback((e: any) => {
    e.preventDefault();
    reset();
    setSearchTerm("");
    setPage(1);
    getData("", 1);
  }, [getData, reset]);

  const handleSearch = useCallback((e: React.ChangeEvent<HTMLInputElement>) => {
    const value = e.target.value;
    setSearchTerm(value);
    setPage(1); // Reset to first page on new search
    getData(value, 1);
  }, [getData]);
  return (
    <div className="space-y-2.5">
      <style>
        {`
          .form__group {
            margin: 0 !important;
            gap: 4px !important;
          }
          .form__group .form__field {
            height: 32px !important;
            padding: 0px 10px !important;
            font-size: 12px !important;
            border-radius: 6px !important;
            border: 1px solid #e2e8f0 !important;
          }
          .form__group .form__label {
            font-size: 11px !important;
            font-weight: 500 !important;
            margin-bottom: 0 !important;
            color: #475569 !important;
          }
          .form__group__check {
            margin: 0 !important;
            gap: 6px !important;
            align-items: center !important;
          }
          .form__group__check span {
            font-size: 11px !important;
            font-weight: 500 !important;
            color: #475569 !important;
          }
          .form__group__check .w-10 {
            width: 1.75rem !important;
            height: 1rem !important;
            flex-shrink: 0 !important;
          }
          .form__group__check .after\\:h-4 {
            height: 0.75rem !important;
            width: 0.75rem !important;
          }
          .form__group__check .after\\:top-\\[2px\\] {
            top: 1px !important;
            left: 1px !important;
          }
          .form__group__check .peer-checked\\:after\\:translate-x-full {
            transform: translateX(0.75rem) !important;
          }
        `}
      </style>
      {/* Filter Form */}
      <FormProvider {...methods}>
        <form onSubmit={methods.handleSubmit(onSubmit)} className="flex flex-wrap items-end gap-2.5">
          <div className="relative max-w-md">
            <input
              type="search"
              placeholder="Search invoice, patient, dentist..."
              value={searchTerm}
              onChange={handleSearch}
              className="w-full pl-3 pr-2.5 py-2 rounded-lg border border-slate-200 bg-white text-slate-700 placeholder-slate-400 focus:outline-none focus:ring-2 focus:ring-primary/20 focus:border-primary transition-all text-xs"
            />
          </div>
          <div className="min-w-[140px]">
            <FormDate label="From" name="startDate" />
          </div>
          <div className="min-w-[140px]">
            <FormDate label="To" name="endDate" />
          </div>
          <div className="flex items-center">
            <FormCheck label="Payment Breakdown" name="payments" />
          </div>
          <button
            type="submit"
            className="px-4 py-2.5 rounded-lg bg-gradient-to-r from-primary to-primaryLight text-white font-medium hover:shadow-lg hover:shadow-primary/20 transition-all text-xs whitespace-nowrap h-[32px] flex items-center"
          >
            Download PDF
          </button>
          <button
            onClick={methodReset}
            className="px-4 py-2.5 rounded-lg border border-slate-200 text-slate-600 font-medium hover:bg-slate-50 transition-colors text-xs whitespace-nowrap h-[32px] flex items-center"
          >
            Reset
          </button>
        </form>
      </FormProvider>

      {/* Desktop Table */}
      <div className="hidden md:block bg-white rounded-[8px] shadow-lg shadow-slate-200/50 border border-slate-100 overflow-hidden">
        <div className="overflow-x-auto">
          <table className="w-full">
            <thead className="border-b border-slate-200">
              <tr>
                <th className="px-2.5 py-1.5 text-left text-xs font-semibold text-slate-500 uppercase">Invoice</th>
                <th className="px-2.5 py-1.5 text-left text-xs font-semibold text-slate-500 uppercase">Date</th>
                <th className="px-2.5 py-1.5 text-left text-xs font-semibold text-slate-500 uppercase">Patient</th>
                <th className="px-2.5 py-1.5 text-left text-xs font-semibold text-slate-500 uppercase">Dentist</th>
                <th className="px-2.5 py-1.5 text-left text-xs font-semibold text-slate-500 uppercase">Total</th>
                <th className="px-2.5 py-1.5 text-left text-xs font-semibold text-slate-500 uppercase">Card</th>
                <th className="px-2.5 py-1.5 text-left text-xs font-semibold text-slate-500 uppercase">Cash</th>
                <th className="px-2.5 py-1.5 text-left text-xs font-semibold text-slate-500 uppercase">Bank</th>
                <th className="px-2.5 py-1.5 text-left text-xs font-semibold text-slate-500 uppercase">Discount</th>
                <th className="px-2.5 py-1.5 text-left text-xs font-semibold text-slate-500 uppercase">paid</th>
                <th className="px-2.5 py-1.5 text-left text-xs font-semibold text-slate-500 uppercase">Due/Adv</th>
              </tr>
            </thead>
            <tbody className="divide-y divide-slate-100">
              {payment.map((item: any, index) => {
                const paidAmount = item?.paymentInfo?.reduce((acc: any, curr: any) => acc + curr.card + curr.cash + curr.bankTransfer, 0);
                const discountAmount = item?.paymentInfo?.reduce((acc: any, curr: any) => acc + curr.discount, 0);
                const dueAmount = item?.totalPrice - item?.paymentInfo?.reduce((acc: any, curr: any) => acc + curr.card + curr.cash + curr.bankTransfer + curr.discount, 0);
                const { card = 0, cash = 0, bankTransfer = 0 } = item?.paymentInfo?.reduce(
                  (acc: any, curr: any) => ({ card: acc.card + curr.card, cash: acc.cash + curr.cash, bankTransfer: acc.bankTransfer + curr.bankTransfer }),
                  { card: 0, cash: 0, bankTransfer: 0 }
                );

                return (
                  <React.Fragment key={index}>
                    <tr
                      onClick={() => navigate(`/client/payments/invoice/${item?._id}`)}
                      className="hover:bg-slate-50 cursor-pointer transition-colors"
                    >
                      <td className="px-2.5 py-1.5 text-xs font-medium text-indigo-600">{item?.invoiceNo}</td>
                      <td className="px-2.5 py-1.5 text-xs text-slate-600">{item?.updatedAt?.split("T")[0]}</td>
                      <td className="px-2.5 py-1.5 text-xs font-medium text-slate-800">{item?.fullName}</td>
                      <td className="px-2.5 py-1.5 text-xs text-slate-600">{item?.dentistName} {item?.dentistLastName}</td>
                      <td className="px-2.5 py-1.5 text-xs text-slate-600">{item?.totalPrice}</td>
                      <td className="px-2.5 py-1.5 text-xs font-semibold text-emerald-600">{card}</td>
                      <td className="px-2.5 py-1.5 text-xs font-semibold text-emerald-600">{cash}</td>
                      <td className="px-2.5 py-1.5 text-xs font-semibold text-emerald-600">{bankTransfer}</td>
                      <td className="px-2.5 py-1.5 text-xs text-orange-600">{discountAmount}</td>
                      <td className="px-2.5 py-1.5 text-xs font-semibold text-emerald-600">{paidAmount}</td>
                      <td className={`px-2.5 py-1.5 text-xs font-semibold ${dueAmount > 0 ? "text-red-600" : "text-emerald-600"}`}>{ dueAmount === 0 ? "TOTAL PAID" :dueAmount < 0 ? Math.abs(dueAmount) : dueAmount}</td>
                    </tr>
                    {openpayments && item?.paymentInfo?.map((items: any, indexa: number) => (
                      <tr key={indexa} className="bg-slate-50/30">
                        <td className="px-2.5 py-1 pl-5 text-[10px] text-slate-500">{items?.invoiceNo}</td>
                        <td className="px-2.5 py-1 text-[10px] text-slate-500">{items?.updatedAt?.split("T")[0]}</td>
                        <td className="px-2.5 py-1"></td>
                        <td className="px-2.5 py-1"></td>
                        <td className="px-2.5 py-1 text-[10px] text-slate-600">{items?.payable}</td>
                        <td className="px-2.5 py-1 text-[10px] text-emerald-600">{items?.card}</td>
                        <td className="px-2.5 py-1 text-[10px] text-emerald-600">{items?.cash}</td>
                        <td className="px-2.5 py-1 text-[10px] text-emerald-600">{items?.bankTransfer}</td>
                        <td className="px-2.5 py-1 text-[10px] text-orange-500">{items?.discount}</td>
                        <td className="px-2.5 py-1 text-[10px] text-emerald-600">{items?.paid}</td>
                        <td className={`px-2.5 py-1 text-[10px] font-semibold ${items?.due > 0 ? "text-red-600 bg-red-50" : "text-emerald-600 bg-emerald-50"} rounded`}>{items?.due}</td>
                      </tr>
                    ))}
                  </React.Fragment>
                );
              })}
            </tbody>
          </table>
        </div>
      </div>

      {/* Mobile Cards */}
      <div className="md:hidden space-y-2">
        {payment.map((item: any, index) => {
          const paidAmount = item?.paymentInfo?.reduce((acc: any, curr: any) => acc + curr.card + curr.cash + curr.bankTransfer, 0);
          const dueAmount = item?.totalPrice - item?.paymentInfo?.reduce((acc: any, curr: any) => acc + curr.card + curr.cash + curr.bankTransfer + curr.discount, 0);
          return (
            <div
              key={index}
              onClick={() => navigate(`/client/payments/invoice/${item?._id}`)}
              className="bg-white rounded-lg shadow-sm border border-slate-100 p-3 cursor-pointer hover:shadow-md transition-shadow"
            >
              <div className="flex items-center justify-between mb-1.5">
                <span className="font-medium text-xs text-indigo-600">{item?.invoiceNo}</span>
                <span className="text-[10px] text-slate-500">{item?.updatedAt?.split("T")[0]}</span>
              </div>
              <h3 className="font-semibold text-xs text-slate-800 mb-1.5">{item?.fullName}</h3>
              <div className="grid grid-cols-3 gap-1.5 text-xs">
                <div className="bg-slate-50 rounded-md p-1.5 text-center">
                  <p className="text-[10px] text-slate-500">Total</p>
                  <p className="font-semibold text-slate-700">{item?.totalPrice}</p>
                </div>
                <div className="bg-emerald-50 rounded-md p-1.5 text-center">
                  <p className="text-[10px] text-emerald-600">Paid</p>
                  <p className="font-semibold text-emerald-700">{paidAmount}</p>
                </div>
                <div className={`rounded-md p-1.5 text-center ${dueAmount > 0 ? "bg-red-50" : "bg-emerald-50"}`}>
                  <p className={`text-[10px] ${dueAmount > 0 ? "text-red-600" : "text-emerald-600"}`}>{dueAmount > 0 ? "Due" : "Adv"}</p>
                  <p className={`font-semibold ${dueAmount > 0 ? "text-red-700" : "text-emerald-700"}`}>{dueAmount}</p>
                </div>
              </div>
            </div>
          );
        })}
      </div>

      <BottomTab title="Patient" count={count} onPageChange={onPageChange} />
      {report && <AllPaymentReport closeModal={closeModal} />}
    </div>
  );
}

export default AllLastPayments;
function paymentMethod(card: number, cash: number, bank: number) {
  const methods = [];
  if (card > 0) methods.push("card");
  if (cash > 0) methods.push("cash");
  if (bank > 0) methods.push("bank");

  return methods.length > 0 ? methods.join("/") : "none";
}
